import SecurePayments from "../../components/SecurePayments";
import AudioSamplePlayer from "../../components/AudioSamplePlayer";
import { courses } from "../../data/online-traffic-school";
import ShellCard from "../../components/ShellCard";
import PriceCard from "../../components/PriceCard";
import "./FourHourBDI.css";
import heroBanner from "../../assets/images/4-hour-bdi-online.png";

const FourHourBDI = () => {
  const course = courses?.find((c) => c.id === 1);

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">4 Hour B.D.I. Course</h1>
              <p className="banner-subheading">State of Florida Certified</p>
            </div>
          </div>
        </div>
      </section>

      <main className="bdi-page">
        <div className="container my-5">
          <div className="row mb-4">
            <div className="col-12">
              <ShellCard>
                <div className="row">
                  <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                    Course Details
                  </h3>
                  <p>
                    For a full course description of the 4 Hour B.D.I. Course
                    please{" "}
                    <a href="/4-hour-bdi" className="link-warning">
                      click here
                    </a>
                    .
                  </p>
                </div>

                <div className="row mb-4">
                  <div className="col-12 col-lg-6">
                    <h3 className="h4" style={{ color: "var(--metro-yellow)" }}>
                      Online Benefits
                    </h3>
                    <ul>
                      <li>
                        All materials needed are on the Internet &mdash;
                        register now.
                      </li>
                      <li>
                        Do the course in sections &mdash; go on and off line as
                        many times as needed.
                      </li>
                      <li>Website available 24 hours a day, 7 days a week.</li>
                      <li>You are guaranteed to pass &mdash; free retakes.</li>
                      <li>
                        Live phone personnel available for registration or
                        questions during business hours.
                      </li>
                      <li>FREE phone and email support.</li>
                      <li>
                        No points on your record for the current violation.
                      </li>
                      <li>
                        No insurance increases as long as there is no accident
                        associated with the ticket (statute 626.9541).
                      </li>
                    </ul>
                  </div>
                  <div className="col-12 col-lg-6">
                    <AudioSamplePlayer />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-12">
                    <h3 className="h4 mb-3" style={{ color: "var(--metro-yellow)" }}>
                      How does it work?
                    </h3>

                    <div className="mb-3">
                      <div>
                        <h5
                          className="card-title text-warning"
                          style={{ color: "var(--metro-yellow)" }}
                        >
                          Course Structure
                        </h5>
                        <p className="card-text">
                          The course is divided up into four 50 minute sections,
                          with 10 minute breaks in between. In order to receive
                          credit for time spent on a section, you must save your
                          time before logging off. When you log on again it will
                          take you to where you were when you logged off. Once
                          you read through the material and answer the questions
                          correctly you will then answer and submit the final
                          quiz. The quiz is comprised of 40 multiple choice and
                          true &amp; false questions. You must get 80% (32
                          questions) correct to get credit for the course. You
                          can retake the quiz for free as many times as
                          necessary if you do not pass.
                        </p>
                      </div>
                    </div>

                    <div className="card">
                      <div>
                        <h5 className="card-title text-warning">
                          Registration Process
                        </h5>
                        <p className="card-text">
                          Registration is easy, simply fill in the information
                          asked on the registration page, and answer 10 security
                          questions. Once the registration process is done,
                          simply input the username and password you were issued
                          into the login section and you can start immediately.
                          Or call our registration center at{" "}
                          <a href="tel:1-888-41-METRO">1-888-41-METRO</a> to
                          register by phone.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-12">
                    <div>
                      <h3 className="h4 text-warning mb-4">Course Fee</h3>
                      <p className="lead mb-4">
                        The Course fee is{" "}
                        <strong className="text-warning fs-3">
                          {course?.price || "$29.50"}
                        </strong>
                        . Make a secure payment now using your debit or credit
                        card.
                      </p>
                      <div className="row g-3 justify-content-center">
                        <PriceCard
                          iconClass="fas fa-chalkboard-teacher fa-2x"
                          title="Classroom Course"
                          price={course?.price || "$29.50"}
                          buttonText="Register for Classroom Course"
                          buttonLink="https://classroom.metrotrafficschool.com/create-account/Ng=="
                          buttonProps={{
                            className:
                              "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-primary metro-btn-pulse",
                          }}
                        />
                        <PriceCard
                          iconClass="fas fa-laptop fa-2x"
                          title="Online Course"
                          price={course?.price || "$29.50"}
                          buttonText="Register for Online Course"
                          buttonLink={
                            course?.registerUrl ||
                            "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=Mzgy"
                          }
                          buttonProps={{
                            className:
                              "btn btn-lg px-4 py-3 fw-bold text-dark metro-btn-secondary",
                          }}
                        />
                      </div>
                      <div className="alert text-light mt-4 p-0" role="alert">
                        <strong>Alternative Payment:</strong> If you do not have
                        a credit card you can mail in a money order to our main
                        office (see address below) and once we receive it, we
                        will call you and issue you a username and password. Be
                        sure to include your name and phone number on the money
                        order (checks are not accepted).
                      </div>
                    </div>
                  </div>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default FourHourBDI;
